import rtlDetect from 'rtl-detect';
export class RtlUtil {
    static GetSetRtl(lang) {
        const isRtl = rtlDetect.isRtlLang(lang);
        document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
        return isRtl;
    }
}
